//手机号码验证
export const checkedPhone=(that,phone)=>{
    var TEL_REGEXP = /^1[3456789][0-9]{9}$/;
    if (phone == "" || phone.trim() == "") {
        that.$message.error('手机号码不能为空','warning');
        return false;
    } else if (!TEL_REGEXP.test(phone)) {
        that.$message.error('请输入正确的手机号码','warning');
        return false;
    }else{
        return true;
    }
}
//验证验证码不为空
export const checkedCodeEmpty=(that,code)=>{
    if (code == "" || code.trim() == "") {
        that.$message.error('验证码不能为空','warning');
        return false;
    } else{
        return true;
    }
}
//验证密码不为空
export const checkPwdEmpty=(that,pwd)=>{
    if (pwd == "" || pwd.trim() == "") {
        that.$message.error('密码不能为空','warning');
        return false;
    } else{
        return true;
    }
}
//验证确认密码是否一致
export const confirmPwd=(that,password,password_confirmation)=>{
    if(password!=password_confirmation){
        that.$message.error('2次输入密码不一致，请确认','warning');
        return false;
    }else{
        return true;
    }
}
//验证密码
export const  checkPwd=(that,password)=>{
    var PWD_REGEXP=/^[0-9a-zA-Z_#]{6,16}$/;
    if (password == "" || password.trim() == "") {
        that.$message.error('请输入密码','warning');
        return false;
    } else if (!PWD_REGEXP.test(password)) {
        that.$message.error('请输入6-16为密码','warning');
        return false;
    }else{
        return true;
    }
}

